import { GET_CANNED_RESTRICTIONS_FOR_PROJECT, GET_CONDITIONS_FOR_PROJECT, GET_CUSTOM_RESTRICTIONS_FOR_PROJECT } from "../actions/ActionType";

export const initialState = {
  restrictionsByProjectId: {},
};

export const restrictionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CANNED_RESTRICTIONS_FOR_PROJECT: {
      // console.log("Reducer - GET_CANNED_RESTRICTIONS_FOR_PROJECT", action.payload);
      const { projectId, restrictions } = action.payload;

      return {
        ...state,
        restrictionsByProjectId: { 
          ...state.restrictionsByProjectId, 
          [projectId]: {
            ...state.restrictionsByProjectId[projectId],
            preCannedDR: restrictions
          }
        }
      };
    }

    case GET_CUSTOM_RESTRICTIONS_FOR_PROJECT: {
      // console.log("Reducer - GET_CUSTOM_RESTRICTIONS_FOR_PROJECT", action.payload);
      const { projectId, restrictions } = action.payload;

      return {
        ...state,
        restrictionsByProjectId: { 
          ...state.restrictionsByProjectId, 
          [projectId]: {
            ...state.restrictionsByProjectId[projectId],
            customDR: restrictions
          }
        }
      };
    }

    case GET_CONDITIONS_FOR_PROJECT: {
      // console.log("Reducer - GET_CONDITIONS_FOR_PROJECT", action.payload);
      const { projectId, conditions } = action.payload;

      return {
        ...state,
        restrictionsByProjectId: { 
          ...state.restrictionsByProjectId, 
          [projectId]: {
            ...state.restrictionsByProjectId[projectId],
            conditions: conditions
          }
        }
      };
    }
    default:
      return state;
  }
}